import React from 'react';
import { Link as RouterLink, useParams } from 'react-router-dom';
import { Button, Container, Paper } from '@mui/material';
import { ArrowBack as BackIcon } from '@mui/icons-material';
import JobDetailView from '../../components/jobs/JobDetailView';
import { useToast } from '../../hooks/useToast';

/**
 * A job on its own page, for direct links. From the board the same view opens
 * in a drawer over the list instead.
 */
const JobDetailPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { show, toast } = useToast();

  return (
    <Container maxWidth="md" sx={{ py: { xs: 2, md: 3 } }}>
      <Button component={RouterLink} to="/" startIcon={<BackIcon />} sx={{ mb: 1.5 }}>
        All jobs
      </Button>
      <Paper variant="outlined" sx={{ p: { xs: 2, sm: 4 } }}>
        {id && <JobDetailView key={id} jobId={id} notify={show} titleComponent="h1" />}
      </Paper>
      {toast}
    </Container>
  );
};

export default JobDetailPage;
